"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExhibitionProductWidgetDataSchema = void 0;
var zod_1 = require("zod");
var vertical_product_item_1 = require("../../components/vertical-product-item");
var common_1 = require("./common");
var lib_unit_optimization_item_v1_dto_1 = require("./lib-unit-optimization-item-v1-dto");
/**
 * 기획전 상품 탭 아이템 DTO
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_exhibition_product_dto_widget_v1_exhibition_product_response_dto._internal_.WidgetExhibitionProductResponseTabItemDto.html}
 * */
var WidgetExhibitionProductResponseTabItemDto = lib_unit_optimization_item_v1_dto_1.LibUnitOptimizationItemV1Dto.extend({
    logMeta: zod_1.z.object({
        /** 숙소 카테고리 타입에 사용하는 숫자 */
        contentsType: zod_1.z.string().nullish(),
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        position: zod_1.z.number(),
        /** 레저 LQT 에서 제공하는 상품 타입 */
        productType: zod_1.z.string().nullish(),
    }),
});
/**
 * 기획전 상품 탭 응답 DTO
 * 스와이프에서 스와이프대상이 되는 영역
 * 탭 하위의 탭 아이템은 스와이프 대상이 아니다.
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_exhibition_product_dto_widget_v1_exhibition_product_response_dto._internal_.WidgetExhibitionProductResponseTabDto.html}
 * */
var WidgetExhibitionProductResponseTabDto = zod_1.z.object({
    backgroundImageUrl: zod_1.z.string(),
    /**
     * 탭 헤더
     * */
    header: zod_1.z
        .object({
        icon: zod_1.z.string().nullish(),
        more: zod_1.z.object({
            /** 더보기 link */
            action: common_1.CommonResponseItemActionDto,
            /** 더보기 타이틀 */
            title: zod_1.z.string(),
        }),
        /** 탭명 */
        title: zod_1.z.string(),
        /** 위젯 서브 타이틀 */
        subTitle: zod_1.z.string().nullish(),
    })
        .optional(),
    items: zod_1.z.array(WidgetExhibitionProductResponseTabItemDto),
    /**
     * 기획전 상품 탭 로그 메타 DTO
     * */
    logMeta: zod_1.z.object({
        exhibitionTitle: zod_1.z.string().nullish(),
        /** 기획전 ID */
        object: zod_1.z.string(),
        objectType: zod_1.z.string().nullish(),
        position: zod_1.z.number(),
    }),
});
/**
 * 위젯 기획전 상품형 응답 DTO
 * @see {@link https://yanolja-dev-cx-api-bucket.s3.ap-northeast-2.amazonaws.com/api-document/cx-display-api/classes/controller_widget_exhibition_product_dto_widget_v1_exhibition_product_response_dto.WidgetV1ExhibitionProductResponseDto.html}
 * */
var WidgetV1ExhibitionProductResponseDto = zod_1.z.object({
    /** 위젯 헤더 */
    header: zod_1.z
        .object({
        /** 아이콘 */
        icon: zod_1.z.string().nullish(),
        /** 위젯 서브 타이틀 */
        subTitle: zod_1.z.string().nullish(),
        /** 위젯 타이틀 */
        title: zod_1.z.string().nullish(),
    })
        .nullish(),
    /** 위젯 아이템 */
    items: zod_1.z.array(WidgetExhibitionProductResponseTabDto),
    /** 로그에 들어갈 정보
     * 위젯 기획전 상품 응답 로그 메타 DTO
     * */
    logMeta: zod_1.z.object({ objectContainer: zod_1.z.string(), widgetPosition: zod_1.z.number().optional() }),
});
exports.ExhibitionProductWidgetDataSchema = WidgetV1ExhibitionProductResponseDto;
/**
 * bff 에서 반환할 위젯 타입
 * */
var ConvertedWidgetExhibitionProductResponseTabDto = WidgetExhibitionProductResponseTabDto.omit({
    items: true,
}).extend({
    items: zod_1.z.array(zod_1.z.object({ productTapProps: vertical_product_item_1.VerticalProductItemSchema, logMeta: zod_1.z.record(zod_1.z.unknown()) })),
});
var ConvertedWidgetV1ExhibitionProductResponseDto = WidgetV1ExhibitionProductResponseDto.omit({
    items: true,
}).extend({
    items: zod_1.z.array(ConvertedWidgetExhibitionProductResponseTabDto),
});
var ConvertedExhibitionProductWidgetDataSchema = ConvertedWidgetV1ExhibitionProductResponseDto;
